__turbopack_context__.v({
  "col12": "ThreeColumnScroll-module-scss-module__tO5sUq__col12",
  "col4": "ThreeColumnScroll-module-scss-module__tO5sUq__col4",
  "col6": "ThreeColumnScroll-module-scss-module__tO5sUq__col6",
  "column": "ThreeColumnScroll-module-scss-module__tO5sUq__column",
  "container": "ThreeColumnScroll-module-scss-module__tO5sUq__container",
  "row": "ThreeColumnScroll-module-scss-module__tO5sUq__row",
  "section": "ThreeColumnScroll-module-scss-module__tO5sUq__section",
});
